import { Component, OnInit, ViewChild } from '@angular/core';
import { RosterFormService } from '../Services/roster-form.service';
import { FormGroup, FormArray, ValidationErrors, ReactiveFormsModule } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { PartyService } from '../Services/party.service';
import { MatStepper, MatStep, MatStepperNext, MatStepperPrevious } from '@angular/material/stepper';
import { NgIf } from '@angular/common';
import { MeetingComponent } from '../meeting/meeting.component';
import { MatDivider } from '@angular/material/divider';
import { RosterListComponent } from '../roster-list/roster-list.component';
import { MatButton } from '@angular/material/button';
import { RosterConfirmationComponent } from '../roster-confirmation/roster-confirmation.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AttendanceCompleteComponent } from '../attendance-complete/attendance-complete.component';
@Component({
    selector: 'app-roster-container',
    templateUrl: './roster-container.component.html',
    styleUrls: ['./roster-container.component.scss'],
    providers: [RosterFormService],
    imports: [ReactiveFormsModule, MatStepper, MatStep, NgIf, MeetingComponent, MatDivider, RosterListComponent, MatButton, MatStepperNext, RosterConfirmationComponent, MatProgressSpinner, MatStepperPrevious, AttendanceCompleteComponent]
})
export class RosterContainerComponent implements OnInit {
  public id: string = null;
  public meetingId: string = null;
  public showRosterFlag: boolean = false;
  public step1Complete: boolean = false;
  public step2Complete: boolean = false;
  public step3Complete: boolean = false;
  private _formComplete: boolean = false;
  private _confirmDetailsStep: boolean = false;
  public isProcessing: boolean = false;
  public meetingRecord: any = null;
  private defaultMemberType: string = '';
  public errorMsg: string = '';
  public showCopySuccess = false;
  @ViewChild(MatStepper ) stepper: MatStepper;
  public get form(): FormGroup {
    return this.rosterFormService.form;
  }

  constructor(private rosterFormService: RosterFormService, private partyService: PartyService) {
    this.id = this.GetQueryStringParam("ID");
    console.log(this.id);
    this.id = (this.id === null || undefined || "") ? this.GetQueryStringParam("id") : this.id;

    this.meetingId = this.GetQueryStringParam("meetingid");
    console.log(this.meetingId);
    this.meetingId = (this.meetingId === null || undefined || "") ? this.GetQueryStringParam("meetingid") : this.meetingId;
  }

  ngOnInit(): void {
    this.errorMsg = '';
    this.partyService.getConfig().subscribe(data => {
      console.log(data);
      // TODO change this one back to load the defaultMemberType from server once resync global config table is done
      // this.defaultMemberType = data.Items.$values[0].Properties.$values.find(x => x.Name === "Description").Value;
      this.defaultMemberType = data.Items.$values[0] !== undefined ? data.Items.$values[0].Properties.$values.find(x => x.Name === "Description").Value : "P";
    }, error => console.log(error));
  }

  GetQueryStringParam(param: string): string {
    let url = window.location.href;
    let paramValue = "";

    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      paramValue = httpParams.get(param);
    }
    return paramValue;
  }

  MeetingStepCompleted(ev: any) {
    this.meetingRecord = ev;
    this.showRosterFlag = true;
    this.showRoster;
  }

  get showRoster() {
    return this.showRosterFlag;
  }

  get ShowConfirmationPanel() {

    return this._confirmDetailsStep;
  }

  public get formComplete(): boolean {
    return this._formComplete;
  }

  async confirmUpdates(nextStep: boolean) {
    let isRosterValidatorIgnored = false;
    // don't validate rosterArray when meetingid is found
    if (!!this.meetingId || (this.rosterFormService.rosterArray.length === 0 && this.rosterFormService.newContactsArray.length > 0)){
      // Remove the validators from the FormArray itself
      this.rosterFormService.rosterArray.clearValidators();
      this.rosterFormService.rosterArray.updateValueAndValidity();
      isRosterValidatorIgnored = true;
    }
    this.form.updateValueAndValidity();

    if (this.form.valid && nextStep) {
      this._confirmDetailsStep = true;
      this.step1Complete = true;
      // need to manually go to the next step as some trigger is missing when updating a meeting
      if (!!this.meetingId || isRosterValidatorIgnored){
        this.stepper.selected.completed = false;
        this.stepper.next();
      }
    }
    else {
      this._confirmDetailsStep = false;
      this.errorMsg = '';
    }
  }

  async onSubmit(data: any) {

    // Helper function to create a delay promise
    const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    this.errorMsg = '';
    this.isProcessing = true;
    try {
      let filter = await this.FilterNewContactsArray(data);
      if (filter){
        let result = !!this.meetingId ? await this.UpdateMeetingRecord(data) : await this.CreateActivityandContactRecords(data);
          if (result) {
            this.stepper.selected.completed = true;
            this.stepper.next();

            // Wait 3 seconds then reload the page
            await delay(3000);
            window.location.reload();
          } else {
            this.isProcessing = false;
          }
      } else {
        this.isProcessing = false;
      }
    } catch (error) {
      console.error('Error in onSubmit:', error);
      this.isProcessing = false;
      
      // Handle the specific validation error
      if (error || error.message) {
        this.errorMsg = `Meeting ID: ${this.meetingId}

      Worksite: ${data.Meeting.WorkSite}

      Worksite Id: ${data.Meeting.WorksiteId}

      Data to be transmitted:
      ${JSON.stringify(data.Meeting, null, 2)}

      Error: ${JSON.stringify(error.message || error, null, 2)}`;
      }
    }
  }

  async copyErrorToClipboard() {
    try {
      // Ensure the window/document has focus
      window.focus();
      await navigator.clipboard.writeText(this.errorMsg);
      this.showCopySuccess = true;
      setTimeout(() => this.showCopySuccess = false, 2000);
    } catch (err) {
      console.error('Failed to copy to clipboard:', err);
      // Optional: Show error message to user
      alert('Copy failed. Please select and copy the text manually.');
    }
  }

  async UpdateMeetingRecord(data: any): Promise<boolean> {
    return new Promise((success, error) => {
      data.Meeting.MeetingId = this.meetingId;
      if (!this.rosterFormService.isValid) {
        return;
      }
      this.step2Complete = true;

      this.partyService.updateWorksiteRecord(data.Meeting, this.meetingRecord.Note).subscribe(result => {
        data.Meeting.seqn = result.Properties.$values.find(x => x.Name === "Ordinal").Value.$value;
        var newRecords = data.NewContacts.filter(x => x.isSelected && x.id === "" && x.status === "").length ?? 0;
        var matchedRecords = data.NewContacts.filter(x => x.isSelected && x.id !== "" && x.status === "L").length ?? 0;
        var existingRecords = data.Roster.filter(x => x.isSelected && x.id !== "" && x.status !== "N").length ?? 0;
        console.log(matchedRecords);

        // just update the meeting details if no new attendees are added
        if (newRecords === 0 && matchedRecords === 0 && existingRecords === 0){
          success(true);
        } else {
          this.CreateNewMemberRecord(data, newRecords, matchedRecords, existingRecords, success, error);
        }

        this.AddCheckNewRecordActivity(data, matchedRecords, existingRecords, success, error);

        this.AddAttendanceRecord(data, existingRecords, success, error);
        
      }, error => {
        console.log(error);
        error(error);
      });
    });
  }

  async CreateActivityandContactRecords(data: any): Promise<boolean> {
    return new Promise((success, error) => {

      if (!this.rosterFormService.isValid) {
        return;
      }
      this.step2Complete = true;

      this.partyService.addWorksiteRecord(data.Meeting).subscribe(result => {

        data.Meeting.seqn = result.Properties.$values.find(x => x.Name === "Ordinal").Value.$value;
        var newRecords = data.NewContacts.filter(x => x.isSelected && x.id === "" && x.status === "").length ?? 0;
        var matchedRecords = data.NewContacts.filter(x => x.isSelected && x.id !== "" && x.status === "L").length ?? 0;
        var existingRecords = data.Roster.filter(x => x.isSelected && x.id !== "" && x.status !== "N").length ?? 0;
        console.log(matchedRecords);

        this.CreateNewMemberRecord(data, newRecords, matchedRecords, existingRecords, success, error);

        this.AddCheckNewRecordActivity(data, matchedRecords, existingRecords, success, error);

        this.AddAttendanceRecord(data, existingRecords, success, error);

      }, error => { console.log(error); error(false); });
    });
  }

  CreateNewMemberRecord(data:any, newRecords:number, matchedRecords:number, existingRecords:number, success, error){
    /*Create New Record  */
    data.NewContacts.filter(x => x.isSelected && x.id === "" && x.status === "").forEach((person, index) => {
      person.memberType = this.defaultMemberType;
      // link existing meetingRecord worksite from SiteVisits to Contact
      if (this.meetingRecord.Entity !== null && this.meetingRecord.Entity !== undefined){
        person.Entity = this.meetingRecord.Entity;
      }
      // adding new non-member via Party
      this.partyService.AddNewNonMemberRecord(person, data.Meeting).subscribe(result => {
        person.id = result.Id;
        person.status = "N";
        // update contact if exists
        if (this.meetingRecord.Entity !== null && this.meetingRecord.Entity !== undefined) {
          this.partyService.UpdateEntityOnRecord(person).subscribe(result => {
            // add the attendance record for the member
            this.partyService.addMemberAttendanceRecord(person, data.Meeting).subscribe(result => {
              if (index === (newRecords - 1) && matchedRecords === 0 && existingRecords === 0){
                success(true);
              }
            }, error => { console.log(error); error(false); });
          }, error => { console.log(error); error(false); });
        } else { // no contact exists yet
          this.partyService.addMemberAttendanceRecord(person, data.Meeting).subscribe(result => {
            if (index === (newRecords - 1) && matchedRecords === 0 && existingRecords === 0){
              success(true);
            }
          }, error => { console.log(error); error(false); });
        }
      }, error => { console.log(error); error(false); });

    });
  }

  AddCheckNewRecordActivity(data:any, matchedRecords:number, existingRecords:number, success, error){
    /*:Add Check Record Activity */
    data.NewContacts.filter(x => x.isSelected && x.id !== "" && x.status === "L").forEach((person, index) => {
      console.log("Meeting data",data.meeting);
      this.partyService.addIntegrityCheck(person, data.Meeting).subscribe(result => {
        console.log(result);
      }, error => { console.log(error); error(false); });
      this.partyService.addAttendanceRecord(person, data.Meeting).subscribe(result => {
        if (index === (matchedRecords - 1) && existingRecords === 0){
          success(true);
        }
      }, error => { console.log(error); error(false); });
    });
  }

  AddAttendanceRecord(data:any, existingRecords:number, success, error){
    data.Roster.filter(x => x.isSelected && x.id !== "" && x.status !== "N").forEach((person, index) => {
      this.partyService.addMemberAttendanceRecord(person, data.Meeting).subscribe(result => {
        if (index === (existingRecords - 1)){
          success(true);
        }
      }, error => { console.log(error); error(false); });
    });
  }

  // New method to filter newContactArray based on alreadyRegisteredAttendeeIds
  async FilterNewContactsArray(data): Promise<any> {
    return new Promise((success, error) => {
      this.partyService.CheckAlreadyRegisteredAttendees(this.meetingId).then((registeredIds: string[]) => {
        const registeredMeetingAttendees = registeredIds.map(id => Number(id));

        const filteredContacts = data["NewContacts"].filter(entry => {
          const memberId = entry.id;
          if (memberId !== "" && registeredMeetingAttendees.includes(Number(memberId))) {
            console.log(`Filtering out already registered member ID: ${memberId}`);
          } else {
            return entry;
          }
        });
        // Update the newContactArray with the filtered array
        console.log(`Filtered newContactArray: ${filteredContacts.length} items (removed ${data["NewContacts"].length - filteredContacts.length})`);
        data["NewContacts"] = [...filteredContacts];
        success(true);
      }, error => { console.log(error); error(false); });
    });
  }
}
